import type { FC } from 'react';
import { useSelector } from 'react-redux';
import SoldProductsMobile from './SoldProductsMobile';
import TopSellingProductsMobile from './TopSellingProductsMobile';
import SoldSubscriptionsMobile from './SoldSubscriptionsMobile';
import TopCustomersMobile from './TopCustomersMobile';
import SoldExclusivesMobile from './SoldExclusivesMobile';
import TopSubscribersMobile from './TopSubscribersMobile';
import SubsCancellationReasonsMobile from '../../SubsCancellationReasonsSection/SubsCancellationReasonsMobile';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import StudioBlankSlate from '../../../StudioBlankSlate';
import { getHasAnyReportsData } from '../../../../selectors/reports';
import { StudioSection } from '../../../../types/store';

import s from './ReportsSectionMobile.scss';

interface Props {}

const ReportsSectionMobile: FC<Props> = () => {
  const hasData = useSelector(getHasAnyReportsData);

  if (!hasData) {
    return <StudioBlankSlate activeSection={StudioSection.SHOP_REPORTS} />;
  }

  return (
    <ScrollableContent className={s['root']}>
      <SoldProductsMobile />
      <SoldExclusivesMobile />
      <SoldSubscriptionsMobile />
      <TopSubscribersMobile />
      <SubsCancellationReasonsMobile />
      <TopSellingProductsMobile />
      <TopCustomersMobile />
    </ScrollableContent>
  );
};

ReportsSectionMobile.displayName = 'ReportsSectionMobile';

export default ReportsSectionMobile;
